import { CanvasSVGObjectContentType } from 'constants/canvasSVGObjectContentTypes';
import { useStickyNoteCommand } from 'customHooks/CanvasSVGObjectContentCommands/stickyNoteCommand';
import { useLinkCommand } from 'customHooks/CanvasSVGObjectContentCommands/LinkCommand';
import { useWhiteboardCommand } from 'customHooks/InteractiveObjectContentCommands/whiteboardCommand';

export const useCanvasSVGObjectContentCommandFactory = () => {
  const StickyNoteCommand = useStickyNoteCommand();
  const LinkCommand = useLinkCommand()
  const WhiteboardCommand = useWhiteboardCommand();

  const createCommand = ({ contentType }) => {
    switch (contentType) {
      case CanvasSVGObjectContentType.StickyNote:
        return StickyNoteCommand;
      case CanvasSVGObjectContentType.Link:
        return LinkCommand;
      case CanvasSVGObjectContentType.Whiteboard:
        return WhiteboardCommand;
      default:
        console.error(`ContentType ${contentType} is not supported`);
        return;
    }
  };

  const CanvasSVGCommandFactory = { createCommand };

  return CanvasSVGCommandFactory;
};
